import { DataBean } from "../../DataBean";


export class HealthIDStructureItem extends DataBean {

    public async getHealthIDStructureItemCatalog(idHealthIDStructure: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getHealthIDStructureItemCatalog_Number", [idHealthIDStructure]);
    }

}